// src/components/MachineTable.js
import React from 'react';
import './Machanedteable.css';

const General = () => {
  const headers = [
    'Model',
    'BJ50-V6/S6',
    'BJ90-V6/S6',
    'BJ126-V6/S6',
    'BJ160-V6/S6',
    'BJ200-V6/S6',
  ];

  const rows = [
    ['Dry Cycle Time (S)', '3', '3.2', '4', '5.8', ''],
    ['Oil Tank Capacity (L)', '420', '460', '630', '810', '810'],
    ['Machine Weight (Ton)', '8.2', '10.3', '15', '18.5', '23'],
    ['Machine Size (LxWxH) m', '5.9X1.53X2.2', '6.8X1.62X2.3', '7.2X1.65X2.3', '8.7X2.1X2.3', '9.0X2.4X2.5'],
  ];

  return (
    <div
      className="container"
      style={{ border: '1px solid lightgray', padding: 0, marginTop: 0 }}
    >
      <div className="responsive-table">
        <table>
          <thead>
            <tr>
              <th colSpan={headers.length} className="unit-row">
                General
              </th>
            </tr>
            <tr>
              {headers.map((head) => (
                <th key={head}>{head}</th>
              ))}
            </tr>
          </thead>

          <tbody>
            {rows.map((row, i) => (
              <tr key={i}>
                {row.map((cell, j) => (
                  <td key={j}>{cell}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default General;
